
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.65 13.75v5c0 .345.291.625.65.625h10.4c.359 0 .65-.28.65-.625v-5c0-1.768-1.34-3.344-2.666-4.375H3.316C1.993 10.405.65 11.982.65 13.75zM6.5 5c-1.345 0-2.62-.57-3.485-1.563-1.529 1.751-1.398 4.339.3 5.938h6.37c1.698-1.6 1.829-4.187.3-5.938A4.617 4.617 0 016.5 5zM3.25 3.685V.625m6.5 3.061V.625","stroke":"currentColor","stroke-width":"1.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    